export default "__VITE_ASSET__DpWFqhs___"